(function () {
  'use strict';

  class CartPriceGuard extends HTMLElement {
    constructor() {
      super();
      this.modal = null;
      this.boundHandler = this.handleCheckout.bind(this);
    }

    connectedCallback() {
      this.validateUrl = this.getAttribute('data-validate-url') ||
        (window.avarrioPrices && window.avarrioPrices.validateUrl) || '';

      if (!this.validateUrl) return;

      // Intercept checkout button clicks
      this.addEventListener('click', this.boundHandler);

      // Listen for price updates to show inline banner
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.productPricesUpdate, this.onPricesUpdate.bind(this));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundHandler);
      if (this.unsubscribe) this.unsubscribe();
    }

    handleCheckout(event) {
      var target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
      if (!target) return;

      // Only guard if we have dynamic prices loaded
      if (!window.avarrio || !window.avarrio.productPrices) return;

      event.preventDefault();
      event.stopPropagation();

      this.validate(target);
    }

    validate(checkoutTrigger) {
      var self = this;
      checkoutTrigger.disabled = true;

      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var dynamicPrices = window.avarrio.productPrices;
          var items = [];

          cart.items.forEach(function (item) {
            var variantId = String(item.variant_id);
            // Only validate dynamically-priced items
            if (dynamicPrices[variantId]) {
              items.push({
                variant_id: variantId,
                expected_price: item.price
              });
            }
          });

          // No dynamic items in cart — proceed directly
          if (items.length === 0) {
            self.proceedToCheckout(checkoutTrigger);
            return;
          }

          return fetch(self.validateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) { return res.json(); })
            .then(function (result) {
              checkoutTrigger.disabled = false;

              if (!result.any_changed) {
                self.proceedToCheckout(checkoutTrigger);
              } else {
                self.showModal(result.items, cart.items, checkoutTrigger);
              }
            });
        })
        .catch(function () {
          // On error, let checkout proceed (fail-open)
          checkoutTrigger.disabled = false;
          self.proceedToCheckout(checkoutTrigger);
        });
    }

    proceedToCheckout(trigger) {
      var form = trigger.closest('form') || document.getElementById('cart');
      if (form) {
        form.submit();
      } else {
        window.location.href = '/checkout';
      }
    }

    showModal(changedItems, cartItems, checkoutTrigger) {
      this.removeModal();
      var self = this;

      var cartItemMap = {};
      cartItems.forEach(function (item) {
        cartItemMap[String(item.variant_id)] = item;
      });

      var rows = '';
      changedItems.forEach(function (item) {
        if (!item.changed) return;
        var cartItem = cartItemMap[item.variant_id];
        var title = cartItem ? cartItem.product_title : 'Produkt';
        var oldFormatted = cartItem ? self.formatHellers(cartItem.price) : '\u2014';
        rows += '<tr>' +
          '<td>' + self.escapeHtml(title) + '</td>' +
          '<td class="cpg-modal__price cpg-modal__price--old">' + oldFormatted + '</td>' +
          '<td class="cpg-modal__price cpg-modal__price--new">' + self.escapeHtml(item.formatted) + '</td>' +
          '</tr>';
      });

      var overlay = document.createElement('div');
      overlay.className = 'cpg-overlay';
      overlay.innerHTML =
        '<div class="cpg-modal" role="dialog" aria-modal="true" aria-label="Ceny se zm\u011Bnily">' +
          '<h2 class="cpg-modal__title">Ceny se zm\u011Bnily</h2>' +
          '<p class="cpg-modal__desc">Od doby, kdy jste p\u0159idali produkty do ko\u0161\u00EDku, do\u0161lo ke zm\u011Bn\u011B cen.</p>' +
          '<table class="cpg-modal__table">' +
            '<thead><tr><th>Produkt</th><th>P\u016Fvodn\u00ED cena</th><th>Nov\u00E1 cena</th></tr></thead>' +
            '<tbody>' + rows + '</tbody>' +
          '</table>' +
          '<div class="cpg-modal__actions">' +
            '<button type="button" class="cpg-modal__btn cpg-modal__btn--proceed button button--outline">Pokra\u010Dovat s nov\u00FDmi cenami</button>' +
            '<button type="button" class="cpg-modal__btn cpg-modal__btn--cancel button button--secondary">Zp\u011Bt do ko\u0161\u00EDku</button>' +
          '</div>' +
        '</div>';

      overlay.querySelector('.cpg-modal__btn--proceed').addEventListener('click', function () {
        self.removeModal();
        self.proceedToCheckout(checkoutTrigger);
      });

      overlay.querySelector('.cpg-modal__btn--cancel').addEventListener('click', function () {
        self.removeModal();
        // Reload cart to show updated prices
        window.location.reload();
      });

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) self.removeModal();
      });

      document.body.appendChild(overlay);
      this.modal = overlay;

      // Focus first action button
      overlay.querySelector('.cpg-modal__btn--proceed').focus();
    }

    removeModal() {
      if (this.modal) {
        this.modal.remove();
        this.modal = null;
      }
    }

    onPricesUpdate(event) {
      // Show inline banner on cart page if prices changed vs what's displayed
      var banner = this.querySelector('.cpg-banner');
      if (!event || !event.prices) return;

      var priceElements = document.querySelectorAll('[data-variant-price][data-line-quantity]');
      if (priceElements.length === 0) return;

      // Prices are already updated by product-prices.js, banner is informational
      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'cpg-banner';
        banner.textContent = 'Ceny byly aktualizov\u00E1ny.';
        this.prepend(banner);
        // Auto-hide after 5 seconds
        setTimeout(function () { banner.remove(); }, 5000);
      }
    }

    formatHellers(hellers) {
      var czk = Math.round(hellers / 100);
      var str = czk.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
      return str + '\u00A0K\u010D';
    }

    escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  }

  customElements.define('cart-price-guard', CartPriceGuard);
})();
